<div class="arrows">
  <mat-icon
    [ngClass]="!isShowingLeftOpponentScores ? 'show-player-scores-icon' : ''"
    aria-hidden="false"
    [attr.aria-label]="leftPlayerScoresAriaLabel"
    [fontIcon]="leftPlayerScoresIcon"
    (click)="onShowLeftPlayerScoresIconSelected()"
  ></mat-icon>

  <mat-icon
    [ngClass]="!isShowingRightOpponentScores ? 'show-player-scores-icon' : ''"
    aria-hidden="false"
    [attr.aria-label]="rightPlayerScoresAriaLabel"
    [fontIcon]="rightPlayerScoresIcon"
    (click)="onShowRightPlayerScoresIconSelected()"
  ></mat-icon>
</div>

<div class="game-score-players">
  <div>{{ leftPlayerUsername }}</div>
  <div>{{ centerPlayerUsername }}</div>
  <div>{{ rightPlayerUsername }}</div>
</div>

<div class="player-game-scores">
  <div>
    <div *ngFor="let leftPlayerWhistPoint of leftPlayerWhistPoints">
      <div>{{ leftPlayerWhistPoint }}</div>
    </div>
  </div>

  <div>
    <div *ngFor="let playerPoolPoint of centerPlayerPoolPoints">
      <div>{{ playerPoolPoint }}</div>
    </div>
  </div>

  <div>
    <div *ngFor="let rightPlayerWhistPoint of rightPlayerWhistPoints">
      <div>{{ rightPlayerWhistPoint }}</div>
    </div>
  </div>
</div>
